<template>
  <div>
    <v-card class="pa-3">
      <v-card-title class="headline pl-0 pt-0">Match List</v-card-title>
      <v-layout row>
        <v-layout column xs6>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Person ID
            </div>
            <div v-if="person.personID">{{ person.personID }}</div>
            <div v-if="!person.personID" class="text-danger font-weight-medium">
              No Person ID
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              UTA Account ID
            </div>
            <div v-if="person.parentId">{{ person.parentId }}</div>
            <div v-if="!person.parentId" class="text-muted">—</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Name
            </div>
            <div>
              {{ person.firstEnglish + " " + person.lastEnglish }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Hebrew Name
            </div>
            <div>
              {{
                person.titleHebrew +
                  " " +
                  person.firstHebrew +
                  " " +
                  person.lastHebrew +
                  " " +
                  person.suffixHebrew
              }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Address
            </div>
            <div>
              {{
                person.address1 +
                  " " +
                  person.city +
                  " " +
                  person.state +
                  " " +
                  person.zip
              }}
            </div>
          </v-layout>
        </v-layout>
        <v-layout column xs6>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-200">
              Father
            </div>
            <div>{{ person.father }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-200">
              Father Address
            </div>
            <div>{{ person.fatherAddress }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-200">
              Father In Law
            </div>
            <div>{{ person.fatherInLaw }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-200">
              Father In Law Address
            </div>
            <div>{{ person.fatherInLawAddress }}</div>
          </v-layout>

          <v-layout row class="mb-2">
            <div class="font-weight-medium width-200">
              Tuition Bypass
            </div>
            <div>{{ tuitionAccountStatus }}</div>

            <v-btn
              class="my-0"
              @click="openUpdateTuitionStatus"
              flat
              icon
              color="success"
              style="height: 24px"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-layout>

          <v-layout row class="mb-2">
            <div class="font-weight-medium width-200">
              Tuition Bypass Reason
            </div>
            <div>{{ tuitionAccountStatusReason }}</div>
          </v-layout>
          <!-- <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Account Status
                        </div>
                        <div>{{ accountStatus }}</div>
                    </v-layout> -->
          <!-- <v-layout row class="mb-2">
                        <div class="font-weight-medium width-200">
                            Account Status Note
                        </div>
                        <div>{{ accountStatusNote }}</div>
                    </v-layout> -->
        </v-layout>
      </v-layout>
      <v-layout row class="mb-2">
        <div class="font-weight-medium width-150">
          Phone Numbers
        </div>
        <div>{{ person.phone }}</div>
      </v-layout>
      <v-divider class="mt-3"></v-divider>
      <v-tabs v-model="activeTab" hide-slider>
        <v-tabs-slider color="success"></v-tabs-slider>
        <v-tab
          href="#matches"
          v-bind:class="{
            'selected-tab': activeTab == 'matches',
          }"
          >MATCHES ({{ matches.length }})</v-tab
        >
        <v-tab
          href="#students"
          v-bind:class="{
            'selected-tab': activeTab == 'students',
          }"
          >STUDENTS ({{ students.length }})</v-tab
        >
        <v-tab
          href="#notes"
          v-bind:class="{
            'selected-tab': activeTab == 'notes',
          }"
          >NOTES ({{ getNotes().length }})</v-tab
        >
        <v-tab
          href="#reg-forms"
          v-bind:class="{
            'selected-tab': activeTab == 'reg-forms',
          }"
          >Registration Forms ({{ regForms.length }})</v-tab
        >
        <v-tab
          href="#auto-matches"
          v-bind:class="{
            'selected-tab': activeTab == 'auto-matches',
          }"
          >Pending Auto Matches ({{ pendingAutoMatches.length }})</v-tab
        >
        <v-spacer></v-spacer>
        <div class="font-weight-medium mr-1 pt-2">Reg. Status:</div>
        <div class="pt-2">
          {{ accountStatus }}
        </div>
        <div
          :title="accountStatusNote"
          style="padding-top: 11px !important;"
          class="caption ml-2"
          v-if="accountStatusNote"
        >
          {{ "(" + truncate(accountStatusNote, 30) + ")" }}
        </div>
        <v-btn class="my-0" @click="openUpdateStatus" flat icon color="success">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <!-- <v-btn
                    color="success"
                    class="mr-1"
                    small
                    @click="openUpdateStatus"
                    >Update Status</v-btn
                > -->
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item value="matches">
          <v-btn
            color="success"
            class="mr-1"
            small
            @click="openAddMatch"
            :disabled="isDisabled()"
            >Add Match</v-btn
          >
          <v-btn
            v-if="selectedMatches.length"
            color="success"
            small
            @click="openDeleteMatch"
            >Delete Matches</v-btn
          >
          <v-data-table
            v-model="selectedMatches"
            :headers="matchHeaders"
            :items="matches"
            item-key="id"
            class="elevation-0"
            hide-actions
          >
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <td>
                  <v-checkbox
                    :input-value="props.selected"
                    color="success"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td>
                  <a @click.stop="openMatchInfo(props.item)" class="">{{
                    props.item.doeID
                  }}</a>
                </td>
                <td>
                  {{ props.item.first }}
                </td>
                <td>
                  {{ props.item.last }}
                </td>
                <td>
                  {{ props.item.address }}
                </td>
                <td>
                  {{ props.item.dob | date }}
                </td>
                <td>
                  {{ props.item.datE_REG | date }}
                </td>
                <td>
                  <div>{{ props.item.matchType }}</div>
                  <div class="match-secondary-row">
                    <span
                      :class="
                        props.item.isCurrent === false
                          ? 'error--text font-weight-bold'
                          : 'success--text'
                      "
                    >
                      {{
                        props.item.isCurrent === false ? "Expired" : "Current"
                      }}
                    </span>
                    <span class="ml-2 grey--text text--darken-1">
                      Updated:
                      {{
                        props.item.doeLastUpdated
                          ? $options.filters.date(props.item.doeLastUpdated)
                          : "N/A"
                      }}
                    </span>
                  </div>
                </td>
                <td>
                  <v-icon
                    class=""
                    dark
                    :color="props.item.verified ? 'success' : 'danger'"
                    >{{
                      props.item.verified ? "mdi-check-circle" : "mdi-close"
                    }}</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="students">
          <v-data-table
            v-model="selectedStudents"
            :headers="studentHeaders"
            :items="students"
            item-key="id"
            class="elevation-0 mt-2"
            hide-actions
          >
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <!-- <td>
                                        <v-checkbox
                                            :input-value="props.selected"
                                            color="success"
                                            primary
                                            hide-details
                                        ></v-checkbox>
                                    </td> -->
                <td>
                  <a @click.stop="openStudentInfo(props.item)" class="">{{
                    props.item.id
                  }}</a>
                </td>
                <td>
                  {{ props.item.first }}
                </td>
                <td>
                  {{ props.item.last }}
                </td>
                <td>
                  {{ props.item.address1 }}
                </td>
                <td>
                  {{ props.item.dob | date }}
                </td>
                <td>
                  {{ props.item.source }}
                </td>
                <td>{{ props.item.branch }}</td>
                <td>{{ props.item.status }}</td>
                <!-- <td>
                                        <v-icon
                                            class=""
                                            dark
                                            :color="
                                                props.item.verified
                                                    ? 'success'
                                                    : 'danger'
                                            "
                                            >{{
                                                props.item.verified
                                                    ? "mdi-check-circle"
                                                    : "mdi-close"
                                            }}</v-icon
                                        >
                                    </td> -->
              </tr>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="notes">
          <notes
            v-if="person.personID"
            :accountID="person.personID"
            typeID="VOTE_REG"
            type="VOTE_REG"
            ref="notes"
            :isExpanded="true"
            :hideHeader="true"
            :showCommunicationType="true"
          ></notes>
        </v-tab-item>
        <v-tab-item value="reg-forms">
          <v-btn
            color="success"
            class="mr-1"
            small
            @click="openAddRegistrationForm()"
            :disabled="isDisabled()"
            >Add Registration Form</v-btn
          >
          <v-data-table
            :headers="regFormsHeaders"
            :items="regForms"
            item-key="id"
            class="elevation-0 mt-2"
            hide-actions
          >
            <template v-slot:items="props">
              <tr
                style="cursor: pointer;"
                :active="props.selected"
                @click="openAddRegistrationForm(props.item)"
              >
                <!-- Source: icon + label -->
                <td>
                  <div class="d-flex align-center">
                    <v-icon
                      small
                      :color="props.item.enteredBy === 'ONLINE' ? '#1976d2' : '#78909c'"
                      class="mr-1"
                    >{{ props.item.enteredBy === 'ONLINE' ? 'mdi-web' : 'mdi-pencil' }}</v-icon>
                    <span
                      class="caption font-weight-bold"
                      :style="{ color: props.item.enteredBy === 'ONLINE' ? '#1976d2' : '#546e7a' }"
                    >{{ props.item.enteredBy === 'ONLINE' ? 'Online' : 'Manual' }}</span>
                  </div>
                  <div v-if="props.item.enteredBy !== 'ONLINE'" class="caption" style="color:#90a4ae;">
                    {{ props.item.enteredBy }}
                  </div>
                </td>
                <!-- Name / Type -->
                <td>
                  <div class="font-weight-medium">{{ props.item.name }}</div>
                  <div class="caption" style="color:#90a4ae;">{{ props.item.type }}</div>
                </td>
                <!-- Address / DOB -->
                <td>
                  <div>{{ props.item.address }}</div>
                  <div class="caption" style="color:#90a4ae;">{{ props.item.dob | date }}</div>
                </td>
                <!-- Status chip -->
                <td>
                  <span
                    class="reg-form-status-chip"
                    :style="{ background: regFormStatusBg(props.item.status), color: regFormStatusColor(props.item.status) }"
                  >
                    <v-icon x-small :color="regFormStatusColor(props.item.status)" class="mr-1">{{ regFormStatusIcon(props.item.status) }}</v-icon>
                    {{ props.item.status }}
                  </span>
                </td>
                <!-- Note -->
                <td>{{ truncate(props.item.note, 35) }}</td>
                <!-- Submitted / Entered -->
                <td>
                  <div v-if="props.item.dateSubmitted">
                    <span class="caption font-weight-medium" style="color:#90a4ae;">Submitted: </span>{{ props.item.dateSubmitted | date }}
                  </div>
                  <div v-if="props.item.enteredOn" class="caption" style="color:#90a4ae;">
                    <span class="font-weight-medium">Entered: </span>{{ props.item.enteredOn | date }}
                  </div>
                </td>
                <!-- Matched to DOE -->
                <td>
                  <div v-if="props.item.isMatchedToDOE" class="d-flex align-center">
                    <v-icon small color="#4caf50" class="mr-1">mdi-check-decagram</v-icon>
                    <span class="caption font-weight-bold" style="color:#2e7d32;">{{ props.item.matchedToDoeID }}</span>
                  </div>
                  <span v-if="!props.item.isMatchedToDOE" style="color:#bbb;">—</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="auto-matches">
          <v-data-table
            :headers="autoMatchHeaders"
            :items="pendingAutoMatches"
            item-key="id"
            class="elevation-0 mt-2"
            hide-actions
          >
            <template v-slot:items="props">
              <tr
                @click="openUpdateAutoMatch(props.item)"
                style="cursor: pointer;"
              >
                <td>{{ props.item.doeID }}</td>
                <td>
                  {{ props.item.first }}
                </td>
                <td>
                  {{ props.item.last }}
                </td>
                <td>
                  {{
                    props.item.matchType
                      ? props.item.matchType
                      : props.item.autoMatchType
                  }}
                </td>
                <td>
                  {{ props.item.dob | date }}
                </td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.title }}</td>
                <td>
                  <v-icon
                    class=""
                    dark
                    :color="
                      props.item.status == 'Pending'
                        ? 'rgb(253, 180, 0)'
                        : 'success'
                    "
                    >{{
                      props.item.status == "Pending"
                        ? "mdi-clock"
                        : "mdi-check-circle"
                    }}</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions class="mr-2">
        <v-spacer></v-spacer>
        <v-btn color="default" dark @click="closeMatchDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog persistent v-model="addMatchDialog" max-width="1700">
      <v-card class="pa-3">
        <v-card-title
          class="headline pl-2 py-0"
          v-bind:class="{
            'mb-2': clickedDOE && clickedDOE.first,
            'mb-4': !clickedDOE || !clickedDOE.first,
          }"
        >
          Add Match
        </v-card-title>
        <div
          style="border: #4caf50 2px solid;"
          class="mb-5"
          v-if="clickedDOE && clickedDOE.first"
        >
          <div
            class="px-2"
            style="background-color: #4caf50; color: #fff; width: fit-content;"
          >
            SELECTED:
          </div>
          <div class="pt-2 px-2 pb-1">
            <v-layout class="mb-2 pl-2">
              <div class="width-200 font-weight-medium">
                Name
              </div>
              <div>
                <span class="font-weight-regular mr-2"
                  >({{ clickedDOE.s == "M" ? "MALE" : "FEMALE" }})</span
                >{{ clickedDOE.first + " " + clickedDOE.last }}
              </div>
            </v-layout>
            <v-layout class="mb-2 pl-2">
              <div class="width-200 font-weight-medium">
                Address
              </div>
              <div>
                {{
                  clickedDOE.house +
                    " " +
                    clickedDOE.street +
                    " " +
                    clickedDOE.apt
                }}
              </div>
            </v-layout>
            <v-layout class="mb-2 pl-2">
              <!-- <v-checkbox
                                v-model="clickedDOE.verified"
                                class="my-0 pt-2"
                                hide-details
                                color="success"
                                label="Verified"
                                style="max-width: 110px;"
                            ></v-checkbox> -->
              <v-select
                v-model="clickedDOE.matchType"
                class="my-0 pt-2"
                style="max-width: 150px;"
                label="Match Type"
                :items="['Husband', 'Wife', 'Daughter', 'Son']"
                hide-details
              >
              </v-select>
            </v-layout>
            <!-- <v-layout class="mb-2 pl-2">
                            <v-checkbox
                                v-model="clickedDOE.addressMatch"
                                class="my-0 pt-2"
                                color="success"
                                style="max-width: 170px;"
                                label="Address Match"
                                hide-details
                            ></v-checkbox>
                            <v-checkbox
                                v-model="clickedDOE.phoneMatch"
                                color="success"
                                style="max-width: 200px;"
                                label="Phone Match"
                                class="my-0 pt-2"
                                hide-details
                            ></v-checkbox>
                        </v-layout> -->
          </div>
        </div>

        <div v-if="showDoeGrid">
          <data-grid
            class="simple-datagrid pr-0 doe-table"
            :url="doeUrl"
            :dontSaveFilters="true"
            :hideHeader="true"
            :perPage="6"
            :columns="doeColumns"
            title="DOE"
            ref="doeGrid"
            :beforeSetupGrid="beforeSetupDoeGrid"
            navigationPath="onSearchDOERowClicked"
            navigationField="onSearchDOERowClicked"
            v-bind:hideActions="true"
            :onRowClicked="onSearchDOERowClicked"
            :sortOptions="{
              enabled: true,
              field: 'last',
              type: 'asc',
            }"
          ></data-grid>
        </div>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeAddMatchDialog"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveMatch()"
            >Add Match</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="existingMatchesWarningDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline text-warning pl-0 pt-0">
          Are you sure?
        </v-card-title>
        <div class="mb-3">
          This person is already matched, Do you want to continue?
        </div>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="existingMatchesWarningDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="addMatch()">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteMatchDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">
          Are you sure?
        </v-card-title>
        <div class="mb-3">This will delete the selected matches</div>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteMatchDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="deleteMatches()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="matchInfoDialog" max-width="1000">
      <v-card v-if="clickedMatchDoe" class="pa-3">
        <doe-match-info
          :row="clickedMatchDoe"
          :columns="doeColumns"
        ></doe-match-info>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="matchInfoDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="infoDialog" max-width="1000">
      <v-card v-if="clickedDOE" class="pa-3">
        <doe-match-info
          :row="clickedDOE"
          :columns="doeColumns"
        ></doe-match-info>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="infoDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateTuitionStatusDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pt-0 pb-2 pl-0">
          Update Tuition Bypass
        </v-card-title>
        <div class="caption grey--text mb-3">
          Mark whether this person's tuition requirement is bypassed for voting
          eligibility.
        </div>

        <v-select
          :items="tuitionAccountStatuses"
          v-model="tuitionAccountStatus"
          label="Tuition Bypass"
          clearable
        ></v-select>

        <v-textarea
          v-model="tuitionAccountStatusReason"
          label="Reason for Bypass"
          rows="2"
        ></v-textarea>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeUpdateStatus()"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            :loading="processing"
            @click="saveAccountStatus()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateStatusDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pt-0 pb-2 pl-0">
          Update Voting Registration Status
        </v-card-title>
        <div class="caption grey--text mb-3">
          Track where this person is in the voter registration process.
        </div>
        <v-select
          :items="accountStatuses"
          v-model="accountStatus"
          label="Registration Status"
          clearable
        ></v-select>
        <v-textarea
          v-model="accountStatusNote"
          label="Note"
          rows="2"
        ></v-textarea>
        <v-card-actions class="mr-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeUpdateStatus()"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            :loading="processing"
            @click="saveAccountStatus()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="addRegFormDialog" max-width="600">
      <voting-reg-form
        ref="regFormDialog"
        :form="clickedRegForm"
        :person="person"
        :reload="loadRegForms"
        :close="closeAddRegistrationForm"
      ></voting-reg-form>
    </v-dialog>
    <v-dialog v-model="updateAutoMatchDialog" max-width="900">
      <v-card>
        <!-- Header -->
        <div
          class="auto-match-dialog-header px-4 py-3"
          :style="{ backgroundColor: clickedAutoMatch.status === 'Pending' ? '#fdb400' : '#4caf50' }"
        >
          <v-layout align-center>
            <div>
              <div class="title white--text font-weight-bold">
                Pending Auto Match — Awaiting Confirmation
              </div>
            </div>
            <v-spacer></v-spacer>
            <div class="text-xs-right">
              <div class="auto-match-badge-pending">
                <v-icon small color="white" class="mr-1">mdi-clock</v-icon>
                {{ clickedAutoMatch.status }}
              </div>
              <div class="caption white--text mt-1" style="opacity: 0.8;">
                Name: {{ clickedAutoMatch.title }} &nbsp;·&nbsp; Type:
                {{ clickedAutoMatch.autoMatchType }}
              </div>
            </div>
          </v-layout>
        </div>

        <v-card-text class="pa-0">
          <v-layout row wrap>
            <!-- Left: Person -->
            <v-flex xs12 sm6 class="auto-match-panel auto-match-panel-left">
              <div class="auto-match-panel-header">
                <v-icon small class="mr-1" color="#4caf50">mdi-account</v-icon>
                Person
                <span class="caption grey--text ml-2"
                  >ID: {{ clickedAutoMatch.personID }}</span
                >
              </div>
              <div class="auto-match-info-grid">
                <div class="auto-match-info-row">
                  <span class="auto-match-label">Name</span>
                  <span class="font-weight-medium">
                    {{
                      clickedAutoMatch.anslName
                        ? clickedAutoMatch.anslName
                        : person && person.firstEnglish
                        ? person.firstEnglish + " " + person.lastEnglish
                        : "—"
                    }}
                  </span>
                </div>
                <div
                  class="auto-match-info-row"
                  v-if="
                    clickedAutoMatch.anslHebName ||
                      (person && person.firstHebrew)
                  "
                >
                  <span class="auto-match-label">Hebrew</span>
                  <span dir="rtl">
                    {{
                      clickedAutoMatch.anslHebName
                        ? clickedAutoMatch.anslHebName
                        : person.titleHebrew +
                          " " +
                          person.firstHebrew +
                          " " +
                          person.lastHebrew
                    }}
                  </span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">Address</span>
                  <span>
                    {{
                      clickedAutoMatch.anslAddress
                        ? clickedAutoMatch.anslAddress
                        : person && person.address1
                        ? person.address1 +
                          ", " +
                          person.city +
                          " " +
                          person.zip
                        : "—"
                    }}
                  </span>
                </div>
              </div>
            </v-flex>

            <!-- Divider -->
            <div class="auto-match-column-divider"></div>

            <!-- Right: DOE Record -->
            <v-flex xs12 sm6 class="auto-match-panel auto-match-panel-right">
              <div class="auto-match-panel-header">
                <v-icon small class="mr-1" color="#1976d2"
                  >mdi-card-account-details</v-icon
                >
                DOE Record
                <span class="caption grey--text ml-2"
                  >DOE ID: {{ clickedAutoMatch.doeID }}</span
                >
              </div>
              <div class="auto-match-info-grid">
                <div class="auto-match-info-row">
                  <span class="auto-match-label">Name</span>
                  <span class="font-weight-medium">
                    {{ clickedAutoMatch.first }}
                    <span
                      v-if="clickedAutoMatch.mi && clickedAutoMatch.mi.trim()"
                    >
                      {{ clickedAutoMatch.mi }}.</span
                    >
                    {{ clickedAutoMatch.last }}
                  </span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">Gender</span>
                  <span>{{ getGander(clickedAutoMatch) }}</span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">DOB</span>
                  <span>
                    {{ clickedAutoMatch.dob | date }}
                    <span class="grey--text ml-1" v-if="clickedAutoMatch.age"
                      >· Age {{ clickedAutoMatch.age }}</span
                    >
                  </span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">House</span>
                  <span>{{ clickedAutoMatch.house }}</span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">Street</span>
                  <span>{{ clickedAutoMatch.street }}</span>
                </div>
                <div
                  class="auto-match-info-row"
                  v-if="clickedAutoMatch.apt && clickedAutoMatch.apt.trim()"
                >
                  <span class="auto-match-label">Apt</span>
                  <span>{{ clickedAutoMatch.apt }}</span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">City</span>
                  <span>{{ clickedAutoMatch.city }}</span>
                </div>
                <div class="auto-match-info-row">
                  <span class="auto-match-label">Zip</span>
                  <span>{{ clickedAutoMatch.zip }}</span>
                </div>
                <div
                  class="auto-match-info-row"
                  v-if="clickedAutoMatch.matchedID"
                >
                  <span class="auto-match-label">Matched ID</span>
                  <span>{{ clickedAutoMatch.matchedID }}</span>
                </div>
                <div
                  class="auto-match-info-row"
                  v-if="clickedAutoMatch.studentID"
                >
                  <span class="auto-match-label">Student ID</span>
                  <span>{{ clickedAutoMatch.studentID }}</span>
                </div>
              </div>

              <!-- Match Type selector -->
              <div
                class="mt-4"
                v-if="clickedAutoMatch.autoMatchType == 'FAMILY'"
              >
                <div class="auto-match-panel-subheader">
                  Select Relationship
                </div>
                <v-select
                  :items="['Husband', 'Wife', 'Daughter', 'Son', 'Not Matched']"
                  label="How is this DOE person related?"
                  v-model="clickedAutoMatch.matchType"
                  clearable
                  ref="matchType"
                  :rules="[rules.required]"
                  @change="matchTypeChanged"
                  outline
                ></v-select>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn flat @click="updateAutoMatchDialog = false">Cancel</v-btn>
          <v-btn
            :loading="processing"
            dark
            color="success"
            @click="saveAutoMatch"
          >
            <v-icon small class="mr-1">mdi-check</v-icon>
            Confirm Match
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
import DoeMatchInfo from "./DoeMatchInfo.vue";
import votingRegForm from "./VotingRegForm.vue";
import notes from "../components/Notes.vue";

export default {
  components: {
    DoeMatchInfo,
    votingRegForm,
    notes,
  },
  props: {
    person: Object,
    reload: Function,
    close: Function,
  },
  data: () => ({
    title: "Master List",
    matchDialog: false,
    deleteMatchDialog: false,
    addMatchDialog: false,
    infoDialog: false,
    matchInfoDialog: false,
    existingMatchesWarningDialog: false,
    clickedDOE: {},
    clickedMatchDoe: {},
    selectedMatches: [],
    matches: [],
    students: [],
    selectedStudents: [],
    userID: "",
    processing: false,
    showDoeGrid: false,
    url: "",
    doeUrl: "doe",
    actions: [],
    phoneSearch: "",
    activeTab: "matches",

    updateStatusDialog: false,
    updateTuitionStatusDialog: false,
    accountStatus: "",
    tuitionAccountStatus: "",
    tuitionAccountStatusReason: "",
    accountStatusNote: "",
    accountStatuses: [
      "Registered",
      "Don’t Want To Registrar",
      "Waiting For Application",
      "Received Application ",
    ],

    tuitionAccountStatuses: ["Bypass"],

    regForms: [],
    pendingAutoMatches: [],
    updateAutoMatchDialog: false,
    clickedAutoMatch: {},
    addRegFormDialog: false,
    clickedRegForm: {},

    rules: {
      required: (value) => !!value || "Required.",
    },

    matchHeaders: [
      {
        text: "",
        value: "",
      },
      {
        text: "DOE ID",
        value: "doeID",
      },
      { text: "First", value: "first" },
      { text: "Last", value: "last" },
      { text: "Address", value: "address" },
      { text: "DOB", value: "dob" },
      { text: "Registered On", value: "datE_REG" },
      { text: "Match Type", value: "matchType" },
      { text: "Verified", value: "verified" },
    ],

    doeColumns: [
      {
        field: "isMatched",
        isIcon: true,
        icon: (value) => {
          return value ? "mdi-check-circle" : "mdi-alert";
        },
        iconColor: (value) => {
          return value ? "success" : "#f35123";
        },
      },
      {
        label: "ID",
        field: "reG_ID",
        sortable: true,
        hidden: false,
        showLink() {
          return true;
        },
        filterOptions: {
          enabled: true,
          filterValue: "",
          placeholder: "",
        },
      },
      {
        label: "First",
        field: "first",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          filterValue: "",
          placeholder: "",
        },
      },
      {
        label: "Last",
        field: "last",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          filterValue: "",
          placeholder: "",
        },
      },
      {
        label: "Gander",
        field: "s",
        sortable: true,
        width: "50px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "",
        },
      },
      {
        label: "House",
        field: "house",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          filterValue: "",
          placeholder: "",
        },
      },
      {
        label: "Street",
        field: "street",
        sortable: true,
        width: "250px",
        hidden: false,
        filterOptions: {
          enabled: true,
          filterValue: "",
          placeholder: "",
        },
      },
      {
        label: "Apt",
        field: "apt",
        sortable: true,
        width: "50px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "",
        },
      },
      {
        label: "City",
        field: "city",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "",
        },
      },
      {
        label: "Zip",
        field: "zip",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "",
        },
      },
      {
        sortable: true,
        label: "Matched",
        field: "isMatched",
        type: "boolean",
        formatFn: (value, row) => {
          return row.isMatched ? "Yes" : "No";
        },
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Select",
          filterDropdownItems: [
            { value: true, text: "Yes" },
            { value: false, text: "No" },
          ],
        },
      },
      {
        label: "Matched To",
        field: "matchName",
        width: "250px",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "",
        },
      },
      {
        label: "DOB",
        field: "dob",
        sortable: true,
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "",
        },
      },
    ],

    studentHeaders: [
      // { text: "", value: "" },
      { text: "ID", value: "id" },
      { text: "First", value: "first" },
      { text: "Last", value: "last" },
      { text: "Address", value: "address1" },
      { text: "DOB", value: "dob" },
      { text: "Source", value: "source" },
      { text: "Branch", value: "branch" },
      { text: "Status", value: "status" },
    ],

    regFormsHeaders: [
      { text: "Source", value: "enteredBy", sortable: false, width: "90px" },
      { text: "Name / Type", value: "name" },
      { text: "Address / DOB", value: "address" },
      { text: "Status", value: "status" },
      { text: "Note", value: "note" },
      { text: "Submitted / Entered", value: "dateSubmitted" },
      { text: "Matched to DOE", value: "matchedToDoeID" },
    ],

    autoMatchHeaders: [
      { text: "Doe ID", value: "doeID" },
      { text: "First", value: "first" },
      { text: "Last", value: "last" },
      { text: "Match Type", value: "matchType" },
      { text: "DOB", value: "dob" },
      { text: "Status", value: "status" },
      { text: "Auto Match", value: "title" },
      { text: "", value: "" },
    ],
  }),
  watch: {
    person(newValue, oldValue) {
      this.load(newValue);
    },
  },
  created() {
    if (this.person) {
      this.load(this.person);
    }
  },
  methods: {
    async load(person) {
      if (!person || !person.personID) {
        this.loadAccountStatus();

        return;
      }

      this.selectedMatches = [];

      await this.loadMatches(person.personID);

      const parents = await this.$http.post("api/voting/getParents", [
        person.paternalGrandParentId,
        person.maternalGrandParentId,
      ]);

      const students = await this.$http.get(
        "api/voting/GetStudents?personID=" + person.personID
      );

      const father = parents.find(
        (p) => p.personID == person.paternalGrandParentId
      );
      const fatherInLaw = parents.find(
        (p) => p.personID == person.maternalGrandParentId
      );

      this.students = students;
      this.person.fatherAddress = father ? father.address1 : "";
      this.person.fatherInLawAddress = fatherInLaw ? fatherInLaw.address1 : "";

      this.matchDialog = true;

      const regForms = await this.$http.get(
        "api/votingRegstrationFormStatus/getByID?personID=" + person.personID
      );

      this.regForms = regForms;

      const pendingAutoMatches = await this.$http.get(
        "api/votingRegistrationAutoMatch/GetPendingAutoMatches?personID=" +
          person.personID
      );

      this.pendingAutoMatches = pendingAutoMatches;

      this.loadAccountStatus();
    },
    async loadAccountStatus() {
      const accountSettings = await this.$http.get(
        "api/voting/GetAccountSettings?personID=" +
          this.person.personID +
          (this.person.parentId ? "&accountID=" + this.person.parentId : "")
      );

      if (accountSettings) {
        this.accountStatus = accountSettings.accountStatus;
        this.accountStatusNote = accountSettings.note;
        this.tuitionAccountStatus = accountSettings.tuitionAccountStatus;
        this.tuitionAccountStatusReason =
          accountSettings.tuitionAccountStatusReason;
      } else {
        this.accountStatus = "";
        this.accountStatusNote = "";
        this.tuitionAccountStatus = "";
        this.tuitionAccountStatusReason = "";
      }
    },
    async loadMatches(personID) {
      const matches = await this.$http.get(
        "api/voting/getMatches?personID=" + encodeURIComponent(personID)
      );

      this.matches = matches
        .filter((m) => !m.removed)
        .map((match) => {
          match.address = match.house + " " + match.street;

          return match;
        });
    },
    getNotes() {
      if (!this.$refs || !this.$refs.notes) return [];

      return this.$refs.notes.getNotes();
    },
    openDeleteMatch() {
      this.deleteMatchDialog = true;
    },
    openAddMatch() {
      this.clickedDOE = {};
      this.addMatchDialog = true;
      this.showDoeGrid = true;
    },
    openAddRegistrationForm(row = null) {
      this.clickedRegForm = row ? row : {};
      this.addRegFormDialog = true;

      if (this.$refs.regFormDialog) {
        this.$refs.regFormDialog.resetValidation();
      }
    },
    closeAddRegistrationForm() {
      this.addRegFormDialog = false;
    },
    async loadRegForms() {
      this.regForms = await this.$http.get(
        "api/votingRegstrationFormStatus/getByID?personID=" +
          this.person.personID
      );

      this.reload();
    },
    closeMatchDialog() {
      this.close();

      this.activeTab = "matches";
    },
    isDisabled() {
      return !this.person.personID;
    },
    async openMatchInfo(row) {
      this.clickedMatchDoe = await this.$http.get(
        "api/voting/getDoe?id=" + row.doeID
      );
      this.matchInfoDialog = true;
    },
    openUpdateStatus() {
      this.updateStatusDialog = true;
    },
    openUpdateTuitionStatus() {
      this.updateTuitionStatusDialog = true;
    },
    openUpdateAutoMatch(autoMatch) {
      this.clickedAutoMatch = JSON.parse(JSON.stringify(autoMatch));
      this.updateAutoMatchDialog = true;
    },
    matchTypeChanged(value) {
      if (!value) {
        this.clickedAutoMatch.status = "Pending";

        return;
      }

      if (value == "Not Matched") {
        this.clickedAutoMatch.status = value;
      } else {
        this.clickedAutoMatch.status = "Verified";
      }
    },
    getGander(person) {
      if (this.clickedAutoMatch.autoMatchType == "STUDENT") {
        return person.gander;
      }

      return person.s == "M"
        ? "Male"
        : person.s == "F"
        ? "Female"
        : "Undefined";
    },
    getAddress(person) {
      if (this.clickedAutoMatch.autoMatchType == "STUDENT") {
        return person.address1;
      }

      return person.house + " " + person.street + " " + person.apt;
    },
    getAutoMatchDisplayValue(value) {
      if (value === null || value === undefined || value === "") {
        return "N/A";
      }

      return value;
    },
    getAutoMatchMatchedDisplayValue(value) {
      if (value === true) {
        return "Yes";
      }

      if (value === false) {
        return "No";
      }

      return "N/A";
    },
    async saveAutoMatch() {
      if (!this.$refs.matchType.validate(true)) return;

      this.processing = true;

      try {
        await this.$http.post("api/voting/UpdateMatchStatus", {
          user: this.$store.state.authentication.user,
          matches: [
            {
              status: this.clickedAutoMatch.status,
              matchType: this.clickedAutoMatch.matchType,
              personID: this.clickedAutoMatch.personID,
              id: this.clickedAutoMatch.id,
              doeID: this.clickedAutoMatch.doeID,
              studentID: this.clickedAutoMatch.studentID,
            },
          ],
        });

        this.processing = false;

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.updateAutoMatchDialog = false;
        this.load(this.person);
        this.loadRegForms();
        this.reload();
      } catch (e) {
        this.processing = false;
      }
    },
    closeUpdateStatus() {
      this.updateStatusDialog = false;
      this.updateTuitionStatusDialog = false;

      this.loadAccountStatus();
    },
    async saveAccountStatus() {
      if (this.tuitionAccountStatus && !this.tuitionAccountStatusReason) {
        return this.$notify({
          group: "notification",
          text: "Reason Required",
          type: "error",
        });
      }

      try {
        this.processing = true;

        await this.$http.post("api/voting/saveAccountSettings", {
          personID: this.person.personID,
          accountID: this.person.parentId,
          accountStatus: this.accountStatus,
          note: this.accountStatusNote,
          tuitionAccountStatus: this.tuitionAccountStatus,
          tuitionAccountStatusReason: this.tuitionAccountStatusReason,
        });

        this.updateStatusDialog = false;
        this.updateTuitionStatusDialog = false;

        this.reload();
        this.processing = false;
      } catch (e) {
        this.processing = false;
      }
    },
    truncate(text, count) {
      return truncate(text, count);
    },
    regFormStatusIcon(status) {
      switch (status) {
        case "Matched":    return "mdi-check-decagram";
        case "Completed":  return "mdi-check-circle";
        case "Submitted":  return "mdi-send";
        case "Pending":    return "mdi-clock";
        default:           return "mdi-help-circle";
      }
    },
    regFormStatusColor(status) {
      switch (status) {
        case "Matched":    return "#2e7d32";
        case "Completed":  return "#388e3c";
        case "Submitted":  return "#1565c0";
        case "Pending":    return "#e65100";
        default:           return "#546e7a";
      }
    },
    regFormStatusBg(status) {
      switch (status) {
        case "Matched":    return "#e8f5e9";
        case "Completed":  return "#f1f8e9";
        case "Submitted":  return "#e3f2fd";
        case "Pending":    return "#fff3e0";
        default:           return "#eceff1";
      }
    },
    openStudentInfo(row) {},
    beforeSetupDoeGrid() {
      this.doeColumns.find(
        (c) => c.field == "reG_ID"
      ).linkAction = this.openInfoDialog;

      this.doeColumns.find(
        (c) => c.field == "last"
      ).filterOptions.filterValue = this.person.lastEnglish.slice(0, 4);

      const houseNumber = this.person.address1.split(" ")[0];
      const street = this.person.address1.split(" ")[1];

      this.doeColumns.find(
        (c) => c.field == "house"
      ).filterOptions.filterValue = houseNumber ? houseNumber.slice(0, 4) : "";
      this.doeColumns.find(
        (c) => c.field == "street"
      ).filterOptions.filterValue = street ? street.slice(0, 4) : "";

      this.doeUrl = "doe?isCurrent=true";
    },
    closeAddMatchDialog() {
      this.doeColumns.find(
        (c) => c.field == "first"
      ).filterOptions.filterValue = "";
      this.doeColumns.find((c) => c.field == "last").filterOptions.filterValue =
        "";
      this.doeColumns.find(
        (c) => c.field == "house"
      ).filterOptions.filterValue = "";
      this.doeColumns.find(
        (c) => c.field == "street"
      ).filterOptions.filterValue = "";
      this.clickedDOE = {};
      this.showDoeGrid = false;
      this.addMatchDialog = false;
    },
    openInfoDialog(row) {
      this.clickedDOE = row;
      this.infoDialog = true;
    },
    async deleteMatches() {
      try {
        this.processing = true;

        await this.$http.post("api/voting/RemoveMatches", {
          userID: this.$store.state.authentication.user,
          ids: this.selectedMatches.map((m) => m.id),
        });

        this.$notify({
          text: "Matches Deleted",
          group: "notification",
          type: "success",
        });

        this.processing = false;
        this.loadMatches(this.person.personID);
        this.reload();
        this.deleteMatchDialog = false;
      } catch (e) {
        this.processing = false;
      }
    },
    async saveMatch() {
      if (!this.clickedDOE || !this.clickedDOE.regID) {
        return this.$notify({
          text: "Please select person",
          group: "notification",
          type: "error",
        });
      }
      if (!this.clickedDOE.matchType) {
        return this.$notify({
          text: "Please select Match Type",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const existingMatches = await this.$http.get(
          "api/voting/GetMatchByDoeID?doeID=" + this.clickedDOE.regID
        );

        if (existingMatches && existingMatches.length) {
          this.processing = false;

          this.existingMatchesWarningDialog = true;

          return;
        }

        await this.addMatch();
      } catch (e) {
        this.processing = false;
      }
    },
    async addMatch() {
      try {
        this.processing = true;

        await this.$http.post("api/voting/addMatch", {
          doeID: this.clickedDOE.regID,
          personID: this.person.personID,
          verified: this.clickedDOE.verified ? 2 : 0,
          matchType: this.clickedDOE.matchType,
          matchedByUserID: this.$store.state.authentication.user,
          verifiedByUserID: this.$store.state.authentication.user,
          phoneMatch: this.clickedDOE.phoneMatch ? 1 : null,
          addressMatch: this.clickedDOE.addressMatch ? 1 : null,
        });

        this.$notify({
          text: "Match Saved",
          group: "notification",
          type: "success",
        });

        this.processing = false;
        this.loadMatches(this.person.personID);
        this.loadRegForms();
        this.reload();
        this.closeAddMatchDialog();
        this.existingMatchesWarningDialog = false;
      } catch (e) {
        this.processing = false;
      }
    },
    onSearchDOERowClicked(row) {
      this.clickedDOE = row;
      this.clickedDOE.matchType =
        this.clickedDOE.s == "M"
          ? "Husband"
          : this.clickedDOE.s == "F"
          ? "Wife"
          : "";
      this.clickedDOE.verified = true;
      this.clickedDOE.phoneMatch = false;
      this.clickedDOE.addressMatch = false;
    },
  },
};
</script>
<style>
.accounts-search.container {
  padding-top: 0px;
}
.doe-table .vgt-table th {
  padding: 0.2em 1.5em 0em 0.75em !important;
}
.doe-table table.vgt-table td {
  padding: 0.5em 0.75em 0.5em 0.75em !important;
}
.doe-table .table.vgt-table {
  font-size: 14px !important;
}
.doe-table .vgt-table th.filter-th {
  padding: 0.2em 0.75em 0.5em 0.75em !important;
}
.selected-tab {
  color: rgb(76, 175, 80) !important;
  border-bottom: 1px solid rgb(76, 175, 80) !important;
}
.reg-form-status-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 2px 9px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.match-secondary-row {
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
}
.auto-match-dialog-header {
  transition: background-color 0.2s;
}
.auto-match-badge-pending {
  display: inline-flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}
.auto-match-panel {
  padding: 16px 20px 20px;
}
.auto-match-panel-left {
  border-right: 1px solid #e0e0e0;
}
.auto-match-column-divider {
  display: none;
}
.auto-match-panel-header {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #444;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.auto-match-panel-subheader {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 6px;
}
.auto-match-section-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #888;
  margin-bottom: 6px;
  margin-top: 2px;
}
.auto-match-info-grid {
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  overflow: hidden;
}
.auto-match-info-row {
  display: flex;
  align-items: baseline;
  padding: 7px 12px;
  font-size: 13px;
  border-bottom: 1px solid #f0f0f0;
}
.auto-match-info-row:last-child {
  border-bottom: none;
}
.auto-match-info-row:nth-child(even) {
  background-color: #fafafa;
}
.auto-match-label {
  min-width: 100px;
  font-weight: 500;
  color: #777;
  flex-shrink: 0;
  font-size: 12px;
}
</style>
